(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9983],{

/***/ 89745:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/portfolio",
      function () {
        return __webpack_require__(71031);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PortfolioListSet; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 견적 검증
var PortfolioListSet = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PORTFOLIO */ .Z.PORTFOLIO).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PortfolioListSet(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 71031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customizing_portfolio; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.js + 36 modules
var Layout = __webpack_require__(49807);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/customizing/portfolio/Portfolio-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin: 0 auto 40px auto;\n  & p {\n    color: #212529;\n    font-size: 18px;\n  }\n  word-break: keep-all;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 20%;\n  word-break: keep-all;\n\n  .sidebar-widget {\n    padding: 20px;\n  }\n\n  .section-title {\n    font-size: 1.3rem;\n  }\n\n  @media screen and (max-width: 350px) {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 351px) and (max-width: 991px) {\n    width: 100%;\n    & ul {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n    & li {\n      width: 45%;\n    }\n  }\n\n  @media screen and (min-width: 991px) and (max-width: 1200px) {\n    width: 30%;\n  }\n\n  @media screen and (max-width: 1200px) {\n    .sidebar-widget {\n      & h5 {\n        font-size: 1.2rem;\n      }\n      & li {\n        padding: 10px 0.5rem;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n\n  @media screen and (max-width: 350px) {\n    width: 100%;\n  }\n  @media screen and (min-width: 351px) and (max-width: 991px) {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 991px) and (max-width: 1200px) {\n    width: 70%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  overflow: hidden;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n  margin-bottom: 25px;\n  :hover {\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  max-height: 200px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  height: 180px;\n  max-height: 200px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 20px 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c90fdf12-0"
})(_templateObject());
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-1"
})(_templateObject1());
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-2"
})(_templateObject2());
var Sidebar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-3"
})(_templateObject3());
var ContentsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-4"
})(_templateObject4());
var SingleContentBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-5"
})(_templateObject5());
var SingleContentImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-6"
})(_templateObject6());
var SingleContentImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-c90fdf12-7"
})(_templateObject7());
var SingleContentTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c90fdf12-8"
})(_templateObject8());

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
// EXTERNAL MODULE: ./redux/action/quickViewAction.js
var quickViewAction = __webpack_require__(43181);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/customizing/portfolio/PortfolioQuickView.js
function PortfolioQuickView_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PortfolioQuickView_templateObject() {
    var data = PortfolioQuickView_taggedTemplateLiteral([
        "\n  width: 100%;\n  /* height: 80vh; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n  & h4 {\n  }\n  & li {\n    margin-bottom: 1rem;\n    :last-of-type {\n      margin-bottom: 0;\n    }\n  }\n  @media screen and (max-width: 991px) {\n    & h4 {\n      font-size: 24px;\n    }\n    & h6 {\n      font-size: 18px;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    & h4 {\n      font-size: 20px;\n    }\n    & h6 {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    PortfolioQuickView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PortfolioQuickView_templateObject1() {
    var data = PortfolioQuickView_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  @media screen and (max-width: 575px) {\n    width: 100%;\n  }\n"
    ]);
    PortfolioQuickView_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PortfolioQuickView_templateObject2() {
    var data = PortfolioQuickView_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  & img {\n    margin: auto 0;\n  }\n"
    ]);
    PortfolioQuickView_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var TestModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1dc6ecf-0"
})(PortfolioQuickView_templateObject());
var SliderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1dc6ecf-1"
})(PortfolioQuickView_templateObject1());
var SliderImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1dc6ecf-2"
})(PortfolioQuickView_templateObject2());
var PortFolioQuickView = function(param) {
    var quickView = param.quickView, _$closeQuickView = param.closeQuickView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* Modal */.u, {
            open: quickView ? true : false,
            onClose: _$closeQuickView,
            children: quickView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "quick-view overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TestModalWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImgWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: quickView.img_url,
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-50",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "mb-20",
                                    children: "\uC0C1\uD488 \uC815\uBCF4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                children: [
                                                    "\uD488\uBA85 : ",
                                                    quickView.name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                children: [
                                                    "\uC7AC\uC9C8 : ",
                                                    quickView.texture
                                                ]
                                            })
                                        }),
                                        quickView.print && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                children: [
                                                    "\uC778\uC1C4 : ",
                                                    quickView.print
                                                ]
                                            })
                                        }),
                                        quickView.size && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                children: [
                                                    "\uC0AC\uC774\uC988 : ",
                                                    quickView.size
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "btn mt-20 py-2 px-5",
                            href: "/customizing/customizing-products/",
                            children: "\uACAC\uC801 \uC694\uCCAD"
                        })
                    ]
                })
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        quickView: state.quickView
    };
};
/* harmony default export */ var PortfolioQuickView = ((0,es/* connect */.$j)(mapStateToProps, {
    closeQuickView: quickViewAction/* closeQuickView */.z
})(PortFolioQuickView));

// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/customizing/portfolio/PortfolioSingleProduct.js






var PortFolioSingleProduct = function(param) {
    var portfolio = param.portfolio, _$openQuickView = param.openQuickView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SingleContentBox, {
            style: {
                cursor: "pointer",
                maxHeight: "fit-content"
            },
            onClick: function() {
                return _$openQuickView(portfolio);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleContentImgWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleContentImg, {
                        src: portfolio.img_url,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SingleContentTitle, {
                    className: "d-flex flex-column align-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: _$openQuickView,
                                children: portfolio.title
                            })
                        }),
                        portfolio.img_alt
                    ]
                })
            ]
        })
    });
};
var mapDispatchToProps = {
    openQuickView: quickViewAction/* openQuickView */.$
};
/* harmony default export */ var PortfolioSingleProduct = ((0,es/* connect */.$j)(null, mapDispatchToProps)(PortFolioSingleProduct));

// EXTERNAL MODULE: ./api/portfolio.js
var portfolio = __webpack_require__(80337);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./components/customizing/portfolio/Portfolio.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var Portfolio = function(param) {
    var dummyList = param.dummyList;
    var ref4 = (0,react.useState)(0), active = ref4[0], setActive = ref4[1];
    var ref1 = (0,react.useState)("P0001"), selectedTags = ref1[0], setSelectedTags = ref1[1];
    var ref2 = (0,react.useState)({}), portfolios = ref2[0], setPortfolios = ref2[1];
    var ref3 = (0,react.useState)([]), activeList = ref3[0], setActiveList = ref3[1];
    var handleClick = function(i, target) {
        setSelectedTags(target);
        setActive(active == i ? 0 : i);
        setActiveList(portfolios[target]);
    };
    var fetchPortfolio = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,portfolio/* PortfolioListSet */.S)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            setPortfolios(res.Data.rows);
                            setActiveList(res.Data.rows["P0001"]);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchPortfolio() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchPortfolio();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uB9DE\uCDA4\uC81C\uC791",
            subTitle: "\uD3EC\uD2B8\uD3F4\uB9AC\uC624",
            pageTitle: SeoMeta/* SeoMeta.portfolio.title */.e.portfolio.title,
            pageDesc: SeoMeta/* SeoMeta.portfolio.description */.e.portfolio.description,
            pageKeyword: SeoMeta/* SeoMeta.portfolio.keywords */.e.portfolio.keywords,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                            className: "col-xl-10 col-lg-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "title heading-1 mb-30",
                                    children: "\uB9DE\uCDA4\uC81C\uC791 \uD3EC\uD2B8\uD3F4\uB9AC\uC624"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "\uC9C0\uC18D \uAC00\uB2A5\uD55C \uBBF8\uB798\uB97C \uC704\uD574 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uAC00 \uD568\uAED8 \uC81C\uACF5\uD55C \uC194\uB8E8\uC158\uB4E4\uC744 \uB9CC\uB098\uBCF4\uC138\uC694"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sidebar, {
                                    className: "primary-sidebar sticky-sidebar",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "btn mb-20",
                                            href: "/customizing/customizing-products/",
                                            style: {
                                                width: "100%",
                                                fontWeight: 500,
                                                fontSize: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fi-rs-magic-wand mr-10"
                                                }),
                                                "\uB9DE\uCDA4 \uC81C\uC791 \uD558\uAE30"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "sidebar-widget widget-category-2 mb-20",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "section-title style-1 mb-20",
                                                    children: "\uD3EC\uC7A5\uC7AC \uC194\uB8E8\uC158"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.portfolio) && Object.keys(dummyList === null || dummyList === void 0 ? void 0 : dummyList.portfolio).map(function(el, i) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            className: "hover-up",
                                                            onClick: function() {
                                                                return handleClick(i, el);
                                                            },
                                                            style: {
                                                                cursor: "pointer"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: active == i ? "cat-item text-brand" : "cat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fi-rs-caret-right mr-5"
                                                                    }),
                                                                    dummyList === null || dummyList === void 0 ? void 0 : dummyList.portfolio[el]
                                                                ]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tab-content wow fadeIn animated ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-pane fade show active",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-grid-4 row",
                                                children: activeList && activeList.map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-lg-4 col-md-6 col-sm-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioSingleProduct, {
                                                            portfolio: el
                                                        })
                                                    }, i);
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioQuickView, {})
            ]
        })
    });
};
var Portfolio_mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var portfolio_Portfolio = ((0,es/* connect */.$j)(Portfolio_mapStateToProps, null)(Portfolio));

;// CONCATENATED MODULE: ./pages/customizing/portfolio/index.js


var PortfolioPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_Portfolio, {})
    });
};
/* harmony default export */ var customizing_portfolio = (PortfolioPage);


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,9807,4027,9774,2888,179], function() { return __webpack_exec__(89745); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);